import locale from '../../locale/ru'

export default {
    data() {
        return {
            messages: locale.messages
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/mixins/messages.js